<template>
  <div class="addon-card">
    <div class="card-header">
      <div class="addon-title">{{ $props.addonTitle }}</div>
      <v-popover v-if="$props.addonDescription" class="addon-tooltip" popover-class="addon-popover" placement="left" trigger="hover">
        <img class="info-icon"
             src="/assets/images/tooltip-info-16.png"
             alt="info-icon"
             @click="openTooltip">
        <template slot="popover">
          <div class="addon-tooltip-description">{{ $props.addonDescription }}</div>
        </template>
      </v-popover>
    </div>
    <ul class="card-body" :class="{'tv-card': $props.cardType === 'tv'}">
      <template v-if="$props.cardType === 'mobile'">
        <li v-for="(feature, index) in $props.addonFeatures"
            :key="compId+index"
            class="feature">
          <img class="feature-img" :src="feature.icon.url"/>
          <p class="feature-description">{{ feature.description }}</p>
        </li>
      </template>
      <li v-else class="feature tv-feature">
        <base-button v-if="hasChannels"
                     variant="text"
                     class="channels-button"
                     @click="emitChannelClickEvent">
          {{ $t('addons.tvPackageChannelButton') }}
        </base-button>
      </li>
    </ul>
    <div class="price-wrapper">
      <div class="price">{{ $props.addonPrice }}<span v-show="$props.addonPrice">&nbsp;{{ $t('addons.currency') }}</span></div>
      <p class="recurring" v-if="$props.recurring">{{ $t('addons.recurringLabel') }}</p>
    </div>
    <base-button :variant="activeAddonCard ? 'secondary' : 'primary'"
                 class="full-width-btn"
                 size="small"
                 @click="emitButtonEvent">
      {{ $props.buttonText }}
    </base-button>
  </div>
</template>

<script>
export default {
  name: 'addon-card',
  props: {
    addonPrice: String,
    addonTitle: String,
    addonDescription: String,
    buttonText: String,
    addonFeatures: {
      type: Array,
      default: () => []
    },
    cardType: {
      type: String,
      default: 'mobile',
      validator: value => {
        const availableTypes = ['mobile', 'tv']
        return availableTypes.includes(value)
      }
    },
    recurring: Boolean,
    activeAddonCard: Boolean,
    hasChannels: Boolean
  },
  computed: {
    compId () {
      return this._uid
    }
  },
  methods: {
    openTooltip () {
      this.$emit('open-tooltip')
    },
    emitButtonEvent () {
      this.$emit('button-click')
    },
    emitChannelClickEvent () {
      this.$emit('view-channels')
    }
  }
}
</script>

<style scoped lang="scss">
.addon-card {
  width: 285px;
  background: $white;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 2.2rem 1.6rem 1.6rem;
  margin: 0 2rem 4rem;
  display: flex;
  flex-direction: column;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .addon-title {
      font-size: 24px;
      font-weight: 600;
      flex-basis: 90%;
    }

    .addon-tooltip {
      margin-top: 0.5rem;
    }
  }

  .card-body {
    margin-top: 1.6rem;
    margin-bottom: 2.4rem;

    &.tv-card {
      margin-top: 0;
      margin-bottom: 1.6rem;
    }

    .feature {
      display: flex;
      align-items: center;
      padding: 1.6rem 0;

      &:not(:first-child) {
        border-top: 1px solid $grey;
      }

      &.tv-feature {
        border-bottom: 1px solid $grey;
      }

      .feature-img {
        display: block;
        width: 100%;
        max-width: 24px;
      }

      .feature-description {
        margin-left: 1.6rem;
        font-size: 1.4rem;
        color: $dark-grey;
        margin-bottom: 0;
      }

      .channels-button {
        font-size: 1.4rem;
        text-decoration: underline;
        color: $text;
      }
    }
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.6rem;
    margin-top: auto;

    .recurring {
      margin: 0;
      font-weight: bold;
    }

    .price {
      font-size: 2.4rem;
      color: $primary;
      font-weight: 600;

      span {
        color: $light-black;
        font-size: 1.6rem;
      }
    }
  }

  .full-width-btn {
    width: 100%;
  }
}
</style>
